<script>
import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import { PACKAGE_GROUP_GYLDENDAL } from "@/common/package-groups-types";
import IconChevronRight from "@/components/icons/white/IconWhiteChevronRight.vue";
import ImageResponsive from "@/components/ImageResponsive.vue";

export default {
  name: "StartView",
  components: {
    IconChevronRight,
    ImageResponsive,
    TgButton
  },
  props: {
    isGyldendal: {
      type: Boolean,
      required: true
    }
  },
  emits: ["next", "skip"],
  computed: {
    gyldendalId() {
      return PACKAGE_GROUP_GYLDENDAL;
    },

    btnColor() {
      return this.isGyldendal ? "gyldendal" : "primary";
    }
  }
};
</script>

<template>
  <div class="onboarding">
    <div class="row my-2">
      <div class="col-12 text-center mb-5 mt-4">
        <ImageResponsive
          class="ml-4"
          src="/assets/img/onboarding/children-with-devices@1x.png"
          presentational
        />
      </div>
      <div class="col-12 text-center">
        <h1 class="onboarding__heading">{{ $t("onboarding.startView.heading") }}</h1>
      </div>
      <div class="col-12 text-center mb-5 px-5">
        <p class="onboarding__lead">{{ $t("onboarding.startView.lead") }}</p>
      </div>
      <div class="col-6 d-flex justify-content-end mt-3">
        <TgButton variant="text" color="grey" @click="$emit('skip')">
          {{ $t("onboarding.startView.skip") }}
        </TgButton>
      </div>
      <div class="col-6 d-flex mt-3">
        <TgButton :color="btnColor" @click="$emit('next')">
          {{ $t("onboarding.startView.start") }}
          <IconChevronRight class="ml-2" role="presentation" />
        </TgButton>
      </div>
    </div>
  </div>
</template>
